import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className=" text-white py-4" style={{ background: "black" }}>
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <small>© TNPY AMPICON 2025 All rights reserved</small>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <small>
              <span
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  letterSpacing: "1px",
                }}
              >
                <span
                  style={{
                    verticalAlign: "middle",
                    marginRight: "6px",
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="#00e6e6"
                    style={{ display: "inline" }}
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="#00e6e6"
                      strokeWidth="2"
                      fill="none"
                    />
                    <path
                      d="M8 12l2 2 4-4"
                      stroke="#00e6e6"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </span>
                Designed & Developed by{" "}
                <a
                  href="https://idlbay.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#00e6e6",
                    fontWeight: "bold",
                    textShadow: "0 0 6px #00e6e6",
                    textDecoration: "none",
                    borderRadius: "6px",
                    padding: "0",
                    marginLeft: "4px",
                  }}
                >
                  IDLBAY
                </a>
              </span>
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
